let selectedRange = null;
let appId = null;
let chatId = null;
let fullTextTranslationState = {
  isRunning: false,
  currentParagraphIndex: 0,
  totalParagraphs: 0,
  consecutiveFailures: 0,
  paragraphs: [],
  paragraphIndexs: [],
  shouldStop: false,
};
let uniqueMarker;

// Office初始化
Office.onReady(async (info) => {
  loadConfig();
  showStatus("插件已就绪", "success");
  console.log("Office Host:", info.host, "Platform:", info.platform);
});

// 切换配置区域显示/隐藏
function toggleConfig() {
  const content = document.getElementById("configContent");
  const toggle = document.getElementById("configToggle");

  if (content.classList.contains("active")) {
    content.classList.remove("active");
    toggle.classList.remove("active");
  } else {
    content.classList.add("active");
    toggle.classList.add("active");
  }
}

// 切换全文翻译配置区域
function toggleFullTextConfig() {
  const content = document.getElementById("fullTextConfigContent");
  const toggle = document.getElementById("fullTextToggle");

  if (content.classList.contains("active")) {
    content.classList.remove("active");
    toggle.classList.remove("active");
  } else {
    content.classList.add("active");
    toggle.classList.add("active");
  }
}

// 配置验证
function validateConfig() {
  const baseUrl = document.getElementById("baseUrl").value.trim();
  const apiKey = document.getElementById("apiKey").value.trim();
  let isValid = true;

  // 清除之前的错误样式
  document.getElementById("baseUrl").classList.remove("validation-error");
  document.getElementById("apiKey").classList.remove("validation-error");

  // 移除之前的错误消息
  const existingErrors = document.querySelectorAll(".validation-message");
  existingErrors.forEach((error) => error.remove());

  // 验证API地址
  if (!baseUrl) {
    showFieldError("baseUrl", "API 地址不能为空");
    isValid = false;
  } else if (!isValidUrl(baseUrl)) {
    showFieldError("baseUrl", "请输入有效的完整的 API 地址");
    isValid = false;
  }

  // 验证API Key
  if (!apiKey) {
    showFieldError("apiKey", "API Key不能为空");
    isValid = false;
  }
  return isValid;
}

// 显示字段错误
function showFieldError(fieldId, message) {
  const field = document.getElementById(fieldId);
  field.classList.add("validation-error");

  const errorDiv = document.createElement("div");
  errorDiv.className = "validation-message";
  errorDiv.textContent = message;
  field.parentNode.appendChild(errorDiv);
}

// 验证URL格式
function isValidUrl(string) {
  try {
    const url = new URL(string);
    const validProtocols = ["http:", "https:"];
    if (!validProtocols.includes(url.protocol)) {
      return false;
    }
    return true;
  } catch (_) {
    return false;
  }
}

// 保存配置到Office设置
function validateInput(input) {
  if (!input.value.trim()) {
    input.style.border = "1px solid red";
  } else {
    input.style.border = "";
  }
}

function saveConfig() {
  if (!validateConfig()) {
    showStatus("配置验证失败，请检查必填项", "error");
    return;
  }
  const config = {
    baseUrl: document.getElementById("baseUrl").value.trim(),
    apiKey: document.getElementById("apiKey").value.trim(),
  };

  // 使用Office.js的设置API保存配置
  if (Office.context.document && Office.context.document.settings) {
    Office.context.document.settings.set("aiTranslatorConfig", JSON.stringify(config));
    Office.context.document.settings.saveAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        toggleConfig();
        showStatus("配置已保存", "success");
      } else {
        showStatus("配置保存失败", "error");
      }
    });
  } else {
    // 降级到localStorage
    localStorage.setItem("aiTranslatorConfig", JSON.stringify(config));
    toggleConfig();
    showStatus("配置已保存到本地", "success");
  }
}

// 加载配置
function loadConfig() {
  let config = null;

  // 尝试从Office设置读取
  if (Office.context.document && Office.context.document.settings) {
    const savedConfig = Office.context.document.settings.get("aiTranslatorConfig");
    if (savedConfig) {
      try {
        config = JSON.parse(savedConfig);
      } catch (e) {
        console.error("解析配置失败:", e);
      }
    }
  }

  // 降级到localStorage
  if (!config) {
    const savedConfig = localStorage.getItem("aiTranslatorConfig");
    if (savedConfig) {
      try {
        config = JSON.parse(savedConfig);
      } catch (e) {
        console.error("解析本地配置失败:", e);
      }
    }
  }

  // 使用默认配置
  config = config || {
    baseUrl: "",
    apiKey: "",
  };

  //  baseUrl: "https://east-newf2cer.fit2cloud.com",
  //   apiKey: "application-bb1cb1141302dfa7cda8e6e9fc204369",

  document.getElementById("baseUrl").value = config.baseUrl || "";
  document.getElementById("apiKey").value = config.apiKey || "";

  return config;
}

// 获取选中的文本
function getSelectedText() {
  Word.run(async (context) => {
    try {
      console.log("获取选中文本");
      const selection = context.document.getSelection();
      selection.load("text");
      await context.sync();
      // 获取段落内的超链接
      const hyperlinks = selection.getHyperlinkRanges();
      hyperlinks.load("length");
      await context.sync();

      // 检查是否包含超链接
      const hasHyperlink = hyperlinks.items.length > 0;
      console.log("选定范围包含超链接: ", hasHyperlink);
      // const searchResults = selection.search("*", { matchWildcards: true });
      // searchResults.load("font/superscript, font/subscript");
      // await context.sync();

      // let hasSuperscript = false;
      // let hasSubscript = false;

      // // 检查搜索结果
      // for (let result of searchResults.items) {
      //   if (result.font.superscript) hasSuperscript = true;
      //   if (result.font.subscript) hasSubscript = true;
      // }

      // console.log("选定范围包含上标: ", hasSuperscript);
      // console.log("选定范围包含下标: ", hasSubscript);

      // await context.sync();

      if (selection.text && selection.text.trim()) {
        document.getElementById("sourceText").value = selection.text;
        selectedRange = selection;
        showStatus("已获取选中文本", "success");
      } else {
        showStatus("请先选中要翻译的文本", "error");
      }
    } catch (error) {
      console.error("获取选中文本失败:", error);
      showStatus("获取选中文本失败", "error");
    }
  });
}

// 获取应用信息
async function getApplicationProfile(config) {
  try {
    const response = await fetch(`${config.baseUrl}/chat/api/application/profile`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(config.apiKey && { Authorization: `Bearer ${config.apiKey}` }),
      },
    });

    if (!response.ok) {
      throw new Error(`获取应用信息失败: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    if (data.code === 200 && data.data && data.data.id) {
      return data.data.id;
    } else {
      throw new Error(`应用信息响应异常: ${data.message || "未知错误"}`);
    }
  } catch (error) {
    console.error("获取应用信息失败:", error);
    throw error;
  }
}

// 获取对话ID
async function getChatId(config, refresh = false) {
  try {
    if (config.chatId && !refresh) {
      return config.chatId;
    }
    if (!config.baseUrl || !config.apiKey) {
      return;
    }
    const response = await fetch(`${config.baseUrl}/chat/api/open`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(config.apiKey && { Authorization: `Bearer ${config.apiKey}` }),
      },
    });

    if (!response.ok) {
      throw new Error(`获取对话ID失败: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    if (data.code === 200 && data.data) {
      config.chatId = data.data;
      return data.data;
    } else {
      throw new Error(`对话ID响应异常: ${data.message || "未知错误"}`);
    }
  } catch (error) {
    console.error("获取对话ID失败:", error);
    showStatus("获取对话ID失败", "error");
  }
}

// 处理流式响应
async function processStreamResponse(response) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let result = "";

  try {
    while (true) {
      const { done, value } = await reader.read();

      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      const lines = chunk.split("\n");

      for (const line of lines) {
        if (line.trim().startsWith("data: ")) {
          try {
            const jsonStr = line.trim().substring(6); // 移除 "data: " 前缀
            if (jsonStr && jsonStr !== "[DONE]") {
              const data = JSON.parse(jsonStr);
              if (data.content) {
                // 处理可能的Unicode转码
                let content = data.content;
                try {
                  // 尝试解码Unicode
                  content = decodeURIComponent(content.replace(/\\u/g, "%u"));
                } catch (e) {
                  // 如果解码失败，使用原始内容
                }
                result += content;

                // 实时更新翻译结果显示
                document.getElementById("translatedText").value = result;
              }
            }
          } catch (e) {
            console.warn("解析流数据失败:", e, line);
          }
        }
      }
    }
  } finally {
    reader.releaseLock();
  }

  return result;
}

// 发送翻译请求
async function sendTranslationRequest(config, chatId, sourceText, onProgress = null) {
  try {
    const response = await fetch(`${config.baseUrl}/chat/api/chat_message/${chatId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(config.apiKey && { Authorization: `Bearer ${config.apiKey}` }),
      },
      body: JSON.stringify({
        message: sourceText,
        stream: true,
        re_chat: true,
      }),
    });

    if (!response.ok) {
      throw new Error(`翻译请求失败: ${response.status} ${response.statusText}`);
    }

    return await processStreamResponse(response, onProgress);
  } catch (error) {
    console.error("发送翻译请求失败:", error);
    throw error;
  }
}

// 翻译文本
async function translateText() {
  if (!validateConfig()) {
    showStatus("配置验证失败，请检查必填项", "error");
    return;
  }
  const sourceText = document.getElementById("sourceText").value.trim();
  const config = loadConfig();

  if (!sourceText) {
    showStatus("请输入要翻译的文本", "error");
    return;
  }
  const translateBtn = document.getElementById("translateBtn");
  const translateBtnText = document.getElementById("translateBtnText");

  // 显示加载状态
  translateBtn.disabled = true;
  translateBtnText.innerHTML = '<span class="loading"></span>翻译中...';
  updateProgress(10, "");

  try {
    // 1. 获取应用信息
    showStatus("正在获取应用信息...", "success");
    updateProgress(30, "");

    if (!appId) {
      appId = await getApplicationProfile(config);
    }

    // 2. 获取对话ID
    showStatus("正在创建对话会话...", "success");
    updateProgress(50, "");

    chatId = await getChatId(config);

    // 3. 发送翻译请求
    showStatus("正在翻译文本...", "success");
    updateProgress(70, "");

    // 清空之前的翻译结果
    document.getElementById("translatedText").value = "";

    const translatedText = await sendTranslationRequest(config, chatId, sourceText);

    updateProgress(100, "");

    if (translatedText && translatedText.trim()) {
      document.getElementById("translatedText").value = translatedText.trim();
      document.getElementById("insertBtn").disabled = false;
      document.getElementById("copyBtn").disabled = false;
      showStatus("翻译完成", "success");
    } else {
      showStatus("翻译结果为空，请重试", "error");
    }
  } catch (error) {
    console.error("翻译出错:", error);
    showStatus(`翻译失败: ${error.message}`, "error");
  } finally {
    // 恢复按钮状态
    translateBtn.disabled = false;
    translateBtnText.innerHTML = "🚀 开始翻译";
    setTimeout(() => updateProgress(0, ""), 1000);
  }
}

// 插入翻译结果
async function insertTranslation() {
  const translatedText = document.getElementById("translatedText").value;

  if (!translatedText) {
    showStatus("没有翻译结果可插入", "error");
    return;
  }
  await Word.run(async (context) => {
    try {
      selectedRange = context.document.getSelection();
      if (selectedRange) {
        selectedRange.insertText(translatedText, Word.InsertLocation.replace);
      } else {
        context.document.getSelection().insertText(translatedText, Word.InsertLocation.replace);
      }
      await context.sync();
      showStatus("译文已插入文档", "success");
    } catch (error) {
      console.error("插入文本失败:", error);
      showStatus("插入失败，请重试", "error");
    }
  });
}
// 复制翻译结果
function copyTranslation() {
  const translatedText = document.getElementById("translatedText").value;

  if (!translatedText) {
    showStatus("没有翻译结果可复制", "error");
    return;
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(translatedText)
      .then(() => {
        showStatus("译文已复制到剪贴板", "success");
      })
      .catch(() => {
        showStatus("复制失败，请手动复制", "error");
      });
  } else {
    // 降级方案：选中文本
    const textarea = document.getElementById("translatedText");
    textarea.select();
    textarea.setSelectionRange(0, 99999);
    try {
      document.execCommand("copy");
      showStatus("译文已复制到剪贴板", "success");
    } catch (err) {
      showStatus("复制失败，请手动复制", "error");
    }
  }
}

// 显示状态消息
function showStatus(message, type) {
  const statusEl = document.getElementById("status");
  statusEl.textContent = message;
  statusEl.className = `status ${type}`;

  // 3秒后清除状态
  setTimeout(() => {
    statusEl.textContent = "";
    statusEl.className = "";
  }, 3000);
}

function onTranslateModeChange() {
  const fullTextMode = document.getElementById("fullTextMode").value;
  const mixModeConfig = document.getElementById("mixModeConfig");

  if (fullTextMode === "mix") {
    mixModeConfig.style.display = "block";
  } else {
    mixModeConfig.style.display = "none";
  }
}

// 错误处理和重试机制
function withRetry(fn, maxRetries = 3) {
  return async function (...args) {
    let lastError;
    for (let i = 0; i < maxRetries; i++) {
      try {
        return await fn.apply(this, args);
      } catch (error) {
        lastError = error;
        if (i < maxRetries - 1) {
          console.warn(`尝试 ${i + 1} 失败，准备重试:`, error);
          await new Promise((resolve) => setTimeout(resolve, 1000 * (i + 1)));
        }
      }
    }
    throw lastError;
  };
}

// 开始全文翻译
async function startFullTextTranslation() {
  if (!validateConfig()) {
    showStatus("请先配置API地址和密钥", "error");
    return;
  }

  if (Office.context.host !== Office.HostType.Word) {
    showStatus("全文翻译功能仅支持 Word 文档", "error");
    return;
  }

  // 重置状态
  fullTextTranslationState = {
    isRunning: true,
    currentParagraphIndex: 0,
    totalParagraphs: 0,
    consecutiveFailures: 0,
    paragraphs: [],
    paragraphIndexs: [],
    shouldStop: false,
  };

  // 更新UI状态
  document.getElementById("fullTextBtn").disabled = true;
  document.getElementById("stopFullTextBtn").disabled = false;
  document.getElementById("fullTextBtnText").innerHTML = '<span class="loading"></span>准备中...';
  document.getElementById("fullTextProgress").style.display = "block";

  try {
    await Word.run(async (context) => {
      // 获取当前光标位置
      const selection = context.document.getSelection();
      selection.load("isEmpty");
      await context.sync();

      // 确保光标未选中内容
      if (!selection.isEmpty) {
        showStatus("请确保没有选中文本，仅定位光标。", "error");
        return;
      }

      // 尝试获取光标所在段落
      let currentParagraph = selection.parentParagraph;
      let startIndex = -1;

      if (currentParagraph) {
        // 如果 parentParagraph 有效，加载 text 属性
        currentParagraph.load("text");
        await context.sync();
      } else {
        currentParagraph = selection.paragraphs.getFirst();
        currentParagraph.load("text");
        await context.sync();

        // 检查 getFirst 是否有效
        if (!currentParagraph.text && currentParagraph.text !== "") {
          showStatus("光标不在段落中或文档为空，返回空结果。", "error");
          return;
        }
      }
      // 插入临时唯一标记以定位光标所在段落
      uniqueMarker = `TEMP_CURSOR_MARKER_${Date.now()}`;
      selection.insertText(uniqueMarker, "Replace");

      // 获取文档中所有段落
      let allParagraphs = context.document.body.paragraphs;
      allParagraphs.load("items/text");
      await context.sync();

      // 查找包含标记的段落
      for (let i = 0; i < allParagraphs.items.length; i++) {
        const paragraphText = allParagraphs.items[i].text;
        if (paragraphText.includes(uniqueMarker)) {
          startIndex = i;
          break;
        }
      }

      // 移除临时标记
      selection.select();
      selection.insertText("", "Replace");
      await context.sync();

      // 如果未找到光标所在段落，直接返回
      if (startIndex === -1) {
        showStatus("无法定位光标所在段落。", "error");
        return;
      }
      allParagraphs.load("items/text");
      await context.sync();
      // 收集从光标所在段落到末尾的非空段落
      for (let i = startIndex; i < allParagraphs.items.length; i++) {
        const paragraph = allParagraphs.items[i];
        const paragraphText = paragraph.text.trim(); // 去除首尾空格和换行符
        if (paragraphText.length > 0) {
          // 只添加非空段落
          fullTextTranslationState.paragraphs.push(paragraph);
          fullTextTranslationState.paragraphIndexs.push({ index: i });
        }
      }

      // 更新 totalParagraphs
      fullTextTranslationState.totalParagraphs = fullTextTranslationState.paragraphs.length;

      if (fullTextTranslationState.totalParagraphs === 0) {
        throw new Error("从光标位置开始没有找到需要翻译的段落");
      }

      updateProgress(0, `准备翻译 ${fullTextTranslationState.totalParagraphs} 个段落`);
    });

    // 开始逐段翻译;
    await processNextParagraph();
  } catch (error) {
    console.error("全文翻译初始化失败:", error);
    showStatus(`全文翻译失败: ${error.message}`, "error");
    stopFullTextTranslation();
  }
}

// 处理下一个段落
async function processNextParagraph() {
  if (fullTextTranslationState.shouldStop) {
    stopFullTextTranslation();
    return;
  }

  const { currentParagraphIndex, totalParagraphs, paragraphs, paragraphIndexs } = fullTextTranslationState;
  if (currentParagraphIndex >= totalParagraphs) {
    // 翻译完成
    completeFullTextTranslation();
    return;
  }

  const currentParagraph = paragraphs[currentParagraphIndex];
  const paragraphText = currentParagraph.text.trim();

  updateProgress(
    ((currentParagraphIndex + 1) / totalParagraphs) * 100,
    `正在翻译第 ${currentParagraphIndex + 1}/${totalParagraphs} 段落`
  );

  try {
    // 翻译当前段落
    const config = loadConfig();
    const mode = document.getElementById("fullTextMode").value;
    const translatedText = await callTranslationAPI(paragraphText, config);
    // 根据配置插入或替换文本
    console.log("当前段落索引:", currentParagraphIndex, "模式:", mode, "翻译文本:", translatedText);
    await Word.run(async (context) => {
      let currentParagraphs = context.document.body.paragraphs;
      currentParagraphs.load("items/text");
      await context.sync();

      if (mode === "insert") {
        const current = currentParagraphs.items[paragraphIndexs[currentParagraphIndex].index + currentParagraphIndex];
        current.insertText("\n" + translatedText, Word.InsertLocation.end);
        await context.sync();
      } else if (mode === "replace") {
        const current = currentParagraphs.items[paragraphIndexs[currentParagraphIndex].index];
        current.load("text");
        await context.sync();
        current.insertText(translatedText, Word.InsertLocation.replace);
      } else {
        const current = currentParagraphs.items[paragraphIndexs[currentParagraphIndex].index];
        current.load("text");
        await context.sync();

        let mixModeConfig = {
          superscript: document.getElementById("mixSuperscript").checked,
          subscript: document.getElementById("mixSubscript").checked,
          underline: document.getElementById("mixUnderline").checked,
          hyperlink: document.getElementById("mixHyperlink").checked,
        };

        let hasSuperscript = false;
        let hasSubscript = false;
        let hasHyperlink = false;
        let hasUnderline = false;

        // 获取指定段落的范围
        const range = current.getRange();

        // 在该段落范围内搜索所有文本
        const searchResults = range.search("*", { matchWildcards: true });
        searchResults.load("font/underline, font/subscript, font/superscript");
        await context.sync();

        // 检查搜索结果
        for (let result of searchResults.items) {
          if (result.font.superscript && mixModeConfig.superscript) hasSuperscript = true;
          if (result.font.subscript && mixModeConfig.subscript) hasSubscript = true;
          if (result.font.underline !== "None" && result.font.underline && mixModeConfig.underline)
            hasUnderline = true;
        }
        if (mixModeConfig.hyperlink) {
          // 获取指定段落的范围
          const range = current.getRange();

          // 获取段落内的超链接
          const hyperlinks = range.getHyperlinkRanges();
          hyperlinks.load("length");
          await context.sync();

          // 检查是否包含超链接
          hasHyperlink = hyperlinks.items.length > 0;
        }

        if (hasSuperscript || hasSubscript || hasUnderline || hasHyperlink) {
          // 获取段落末尾位置
          const endRange = current.getRange(Word.RangeLocation.end);

          // 再插入要变色的文本
          const coloredTextRange = endRange.insertText("    " + translatedText, Word.InsertLocation.after);
          coloredTextRange.font.color = "#FF0000";
        } else {
          current.insertText(translatedText, Word.InsertLocation.replace);
        }
        await context.sync();
      }
    });
    // 重置连续失败计数
    fullTextTranslationState.consecutiveFailures = 0;

    showStatus(`第 ${currentParagraphIndex + 1} 段落翻译完成`, "success");
  } catch (error) {
    console.error(`第 ${currentParagraphIndex + 1} 段落翻译失败:`, error);
    fullTextTranslationState.consecutiveFailures++;

    showStatus(
      `第 ${currentParagraphIndex + 1} 段落翻译失败 (连续失败: ${fullTextTranslationState.consecutiveFailures})`,
      "error"
    );

    // 检查连续失败次数
    if (fullTextTranslationState.consecutiveFailures >= 3) {
      showStatus("连续3个段落翻译失败，停止翻译任务", "error");
      stopFullTextTranslation();
      return;
    }
  }

  // 移动到下一个段落
  fullTextTranslationState.currentParagraphIndex++;

  // 延迟一下再处理下一个段落，避免API频率限制
  setTimeout(() => {
    if (fullTextTranslationState.isRunning) {
      processNextParagraph();
    }
  }, 500);
}

async function callTranslationAPI(text, config, maxRetries = 3) {
  let lastError;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      console.log(`开始第 ${attempt}/${maxRetries} 次翻译尝试...`);

      // 首先创建或获取聊天会话ID
      const chatId = await getChatId(config);

      // 发送流式翻译请求
      const result = await sendStreamTranslationRequest(config, chatId, text, attempt);

      console.log(`第 ${attempt} 次尝试成功完成翻译`);
      return result;
    } catch (error) {
      lastError = error;
      console.error(`翻译尝试 ${attempt}/${maxRetries} 失败:`, error);

      if (attempt < maxRetries) {
        const delay = Math.min(1000 * Math.pow(2, attempt - 1), 5000); // 指数退避，最大5秒
        console.log(`等待 ${delay}ms 后进行第 ${attempt + 1} 次重试...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  }
  return "翻译失败。请手动翻译。";
}

async function sendStreamTranslationRequest(config, chatId, sourceText, attempt = 1) {
  try {
    console.log(`发送流式翻译请求 (尝试 ${attempt})`);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      controller.abort();
    }, 30000); // 30秒超时

    const response = await fetch(`${config.baseUrl}/chat/api/chat_message/${chatId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(config.apiKey && { Authorization: `Bearer ${config.apiKey}` }),
      },
      body: JSON.stringify({
        message: sourceText,
        stream: true,
        re_chat: true,
      }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`翻译请求失败: ${response.status} ${response.statusText}`);
    }

    const result = await processStreamResponseWithRetry(response, attempt);
    return result;
  } catch (error) {
    if (error.name === "AbortError") {
      throw new Error("翻译请求超时");
    }
    console.error(`发送翻译请求失败 (尝试 ${attempt}):`, error);
    throw error;
  }
}

async function processStreamResponseWithRetry(response, attempt = 1) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let result = "";
  let lastUpdateTime = Date.now();

  try {
    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        console.log(`流式响应处理完成 (尝试 ${attempt})`);
        break;
      }

      const chunk = decoder.decode(value, { stream: true });
      const lines = chunk.split("\n");

      for (const line of lines) {
        if (line.trim().startsWith("data: ")) {
          try {
            const jsonStr = line.trim().substring(6); // 移除 "data: " 前缀

            if (jsonStr && jsonStr !== "[DONE]") {
              const data = JSON.parse(jsonStr);

              if (data.content) {
                // 处理可能的Unicode转码
                let content = data.content;
                try {
                  // 尝试解码Unicode转义序列
                  content = content.replace(/\\u([0-9a-fA-F]{4})/g, (match, grp) =>
                    String.fromCharCode(parseInt(grp, 16))
                  );
                } catch (e) {
                  // 如果解码失败，使用原始内容
                  console.warn("Unicode解码失败，使用原始内容:", e);
                }

                result += content;
                lastUpdateTime = Date.now();
              }

              // 检查是否有错误信息
              if (data.error) {
                throw new Error(`API返回错误: ${data.error}`);
              }
            }
          } catch (e) {
            console.warn(`解析流数据失败 (尝试 ${attempt}):`, e, "原始数据:", line);
            // 继续处理其他行，不中断整个流程
          }
        }
      }

      // 检查是否长时间没有数据更新（可能连接中断）
      if (Date.now() - lastUpdateTime > 15000) {
        // 15秒无更新
        throw new Error("流式连接可能中断，长时间无数据更新");
      }
    }
  } catch (error) {
    console.error(`流式响应处理失败 (尝试 ${attempt}):`, error);
    throw error;
  } finally {
    try {
      reader.releaseLock();
    } catch (e) {
      console.warn("释放reader锁失败:", e);
    }
  }

  if (!result.trim()) {
    throw new Error("翻译结果为空，可能服务异常");
  }

  return result.trim();
}

// 停止全文翻译
function stopFullTextTranslation() {
  fullTextTranslationState.shouldStop = true;
  fullTextTranslationState.isRunning = false;

  // 恢复UI状态
  document.getElementById("fullTextBtn").disabled = false;
  document.getElementById("stopFullTextBtn").disabled = true;
  document.getElementById("fullTextBtnText").innerHTML = "📄 开始全文翻译";
  document.getElementById("fullTextProgress").style.display = "none";

  showStatus("全文翻译已停止", "success");
}

// 完成全文翻译
async function completeFullTextTranslation() {
  fullTextTranslationState.isRunning = false;

  // 恢复UI状态
  document.getElementById("fullTextBtn").disabled = false;
  document.getElementById("stopFullTextBtn").disabled = true;
  document.getElementById("fullTextBtnText").innerHTML = "📄 开始全文翻译";

  updateProgress(100, `全文翻译完成！共翻译 ${fullTextTranslationState.totalParagraphs} 个段落`);

  showStatus(`全文翻译完成！共翻译 ${fullTextTranslationState.totalParagraphs} 个段落`, "success");

  // 3秒后隐藏进度条
  setTimeout(() => {
    document.getElementById("fullTextProgress").style.display = "none";
  }, 3000);
}

// 更新进度
function updateProgress(percentage, text) {
  const progressBar = document.getElementById("fullTextProgress");
  const progressFill = document.getElementById("progressFill");

  if (percentage > 0) {
    progressBar.style.display = "block";
    progressFill.style.width = `${percentage}%`;
  } else {
    progressBar.style.display = "none";
    progressFill.style.width = "0%";
  }
  // document.getElementById("progressText").textContent = text;
}
